<template>
  <div class="app-container">
    <BjDivider>{{ $t('billingPage.BillingInvoiceStatement') }}</BjDivider>
    <el-form ref="saveForm1" size="mini" class="bj-query-form bj-query-form-for-cal-height">
      <el-row :gutter="20" style="margin-bottom:10px;padding: 10px 10px;">
          <el-col :span="colSpan*4/3">
              <div><span style="font-weight:bolder;">{{ $t('billingPage.Current') }}</span>：$<span style="font-weight:bolder;color: darkslateblue">{{ totalCurrentAmount||0 }}</span></div>
          </el-col>
          <el-col :span="colSpan*4/3">
              <div><span style="font-weight:bolder;">{{ $t('billingPage.In30Day') }}</span>：$<span style="font-weight:bolder;color: darkslateblue">{{ totalIn30DaysAmount||0 }}</span></div>
          </el-col>
          <el-col :span="colSpan*4/3">
              <div><span style="font-weight:bolder;">{{ $t('billingPage.Over30Day') }}</span>：$<span style="font-weight:bolder;color: darkslateblue">{{ totalOver30DaysAmount||0 }}</span></div>
          </el-col>
        </el-row>
    </el-form>
    <BjPage ref="BjPage"
    :query-params="queryParams"
    :col-span="colSpan"
    :get-action="queryApi"
    :radio="radio"
    :before-reset-search="beforeResetSearch"
    :tooltip-config="{ showAll: false, enterable: false }"
    :selection="selection"
    :default-sort="defaultSort"
    @handleSelectionChange="handleSelectionChange"
    @showSetting="SortableTable.show"
    @sort-change="sortChange"
    @header-dragend="SortableTable.handleHeaderDragend"
    @header-contextmenu="SortableTable.handleHeaderContextmenu"
    @afterFetchOriginalData="afterFetchOriginalData"
    >
      <template v-slot:baseForm>
          <el-col :span="colSpan">
            <el-form-item :label="$t('billingPage.Client')" prop="clientCodes">
              <BjSelectLov v-model="queryParams.clientCodes" multiple :clearable="false" :option-list="clientCodeList" :placeholder="$t('billingPage.Client')" @change="handleQuery" />
            </el-form-item>
          </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <el-button type="primary" @click="onCount">{{ $t('billingPage.Counts') }}</el-button>
          <el-button type="primary" class="main-btn" @click="onDown">{{ $t('downloadText') }}</el-button>
          <el-button type="primary" @click="onExport">{{ $t('exportText') }}</el-button>
        </el-col>
      </template>
      <!-- 展示列表 -->
      <template v-slot:tableColumn>
        <vxe-column type="expand" width="40">
          <template #content="{ row }">
            <div style="padding:10px 20px;">
              <vxe-table :data="row.children" :empty-text="$t('table.emptyText')">
                <!-- 排序==>序号展示 -->
                <vxe-column type="seq" width="70" title="table.countText"></vxe-column>
                <vxe-column field="id" :title="$t('billingPage.invoiceNumber')"></vxe-column>
                <vxe-column field="totalAmount" :title="$t('billingPage.invoicePrice')"></vxe-column>
                <vxe-column field="paidAmount" :title="$t('billingPage.Paid')"></vxe-column>
                <vxe-column field="balance" :title="$t('billingPage.Balances')"></vxe-column>
                <vxe-column field="issueDate" :title="$t('billingPage.Date')"></vxe-column>
                <vxe-column field="dueDate" :title="$t('billingPage.dueDate')"></vxe-column>
                <vxe-column field="Period" :title="$t('billingPage.Period')" width="400px"></vxe-column>
                <vxe-column field="week" :title="$t('billingPage.Week')"></vxe-column>
              </vxe-table>
            </div>
          </template>
        </vxe-column>
        <!-- 排序==>序号展示 -->
        <vxe-column type="seq" width="55" align="center" title="table.countText" />
        <template v-for="(col, index) in dropCols">
          <vxe-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :field="col.prop"
            sortable
            :prop="col.prop" :label="col.label" :width="col.width || 'auto'"
            :fixed="col.fixed || false" align="center" class-name="item"
            :title="col.label"
          >
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop == 'cusId'">{{ customerList.bjGet(scope.row.cusId) }}</template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </vxe-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="props">
              <el-button type="text" class="delete-btn" @click="onSend(props.row)">{{ $t('billingPage.send') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { downloadBlob } from '@/utils/index';
import { billApi } from '@/api';

export default {
  name: 'BusinessBillingInvoiceStatement',
  components: {},
  mixins: [pageMiXin],
  data() {
    return {
      selection: true,
      colSpan: 6,
      queryApi: billApi.getBillInvoicesStatementList,
      queryParams: {
        clientCodes: null,
      },
      labelList: [
        { label: this.$t('billingPage.IRClientCode'), prop: 'clientCode', isCheck: true, disabled: false },
        { label: this.$t('billingPage.bpCode'), prop: 'bpCode', isCheck: true, disabled: false },
        { label: this.$t('billingPage.companyName'), prop: 'companyName', isCheck: true, disabled: false, width: 200},
        { label: this.$t('billingPage.Email'), prop: 'billingEmail', isCheck: true, disabled: false, width: 200},
        { label: this.$t('billingPage.Deposit'), prop: 'depositAmount', isCheck: true, disabled: false },
        { label: this.$t('billingPage.Currents'), prop: 'currentAmount', isCheck: true, disabled: false },
        { label: this.$t('billingPage.In30Days'), prop: 'in30DaysAmount', isCheck: true, disabled: false },
        { label: this.$t('billingPage.Over30Days'), prop: 'over30DaysAmount', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: '100' },
      ],
      defaultSort: [],
      totalCurrentAmount: null,
      totalIn30DaysAmount: null,
      totalOver30DaysAmount: null,
      clientCodeList: [],
    };
  },
  mounted() {
    billApi.getClientInfoList().then(res => {
      res.data.forEach(item => {
        item.label = `${item.label} - ${item.value}`;
      });
      this.clientCodeList = res.data;
    });
  },
  methods: {
    // 批量导出
    onExport() {
        if (!this.selectedRows.length) { this.$message.warning(this.$t('billingPage.Customers')); return; }
        const idList = this.selectedRows.map(e => e.clientCode);
        billApi.exportInvoicesStatement({clientCodes: idList}).then(res => {
          downloadBlob(res, `Invoice Statement.xlsx`);
        }).catch(err => {
          console.log(err, 'err');
        });
    },
    sortChange (column) {
      this.queryParams = {
        clientCodes: null,
      };
      this.queryParams.sortedFields = `${column.field} ${String(column.order).toUpperCase()}`;
      this.defaultSort = [{ field: column.field, order: column.order }];
      this.$nextTick(() => {
        this.$refs.BjPage.fetchData();
      });
    },
    // 下载选中数据
    onDown() {
        if (!this.selectedRows.length) { this.$message.warning(this.$t('billingPage.Customers')); return; }
        const idList = this.selectedRows.map(e => e.clientCode);
        billApi.downInvoicesStatement({clientCodes: idList}).then(res => {
          downloadBlob(res, `Invoice Statement.zip`);
        }).catch(err => {
          console.log(err, 'err');
        });
    },
    // 发送邮件
    onSend(e) {
      this.$confirm(`${this.$t('toast.continueTipText')}`, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      }).then(() => {
        billApi.BillInvoicesStatementSendEmail({clientCode: e.clientCode}).then(res => {
          if (res.code == 200) {
            this.msgSuccess(this.$t('toast.operationSuccessText'));
          }
        });
      });
    },
    // 统计
    onCount() {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('billingPage.Customers'));
        return;
      }
      const idList = this.selectedRows.map(e => e.clientCode);
      billApi.BillInvoicesStatementCount({clientCodes: idList}).then(e => {
        if (e.code == 200) {
          this.msgSuccess(this.$t('toast.operationSuccessText'));
          this.totalCurrentAmount = e.data.totalCurrentAmount;
          this.totalIn30DaysAmount = e.data.totalIn30DaysAmount;
          this.totalOver30DaysAmount = e.data.totalOver30DaysAmount;
        }
      });
    },
    afterFetchOriginalData(res) {
      this.totalCurrentAmount = res.totalCurrentAmount;
      this.totalIn30DaysAmount = res.totalIn30DaysAmount;
      this.totalOver30DaysAmount = res.totalOver30DaysAmount;
      res.invoiceStatementInfoList.forEach(item => {
        item.depositAmount = `$${item.depositAmount}`;
        item.currentAmount = `$${item.currentAmount}`;
        item.in30DaysAmount = `$${item.in30DaysAmount}`;
        item.over30DaysAmount = `$${item.over30DaysAmount}`;
        item.children && item.children.forEach(data => {
        data.balance = `$${data.balance}`;
        data.paidAmount = `$${data.paidAmount}`;
        data.totalAmount = `$${data.totalAmount}`;
        data.week = `${data.week}/${data.year}`;
        data.Period = `${data.periodFrom}~${data.periodTo}`;
      });
      });
      this.$nextTick(() => {
        this.$refs.BjPage.tableData = res.invoiceStatementInfoList;
      });
    },
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.defaultSort = [];
      this.queryParams.clientCodes = null;
      return new Promise(resolve => {
        resolve();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .bj-page .el-form-item__label{
  display: none;
}
</style>
